export default "__VITE_ASSET__CtGxpjtA__"